import { FeedbackManager } from '@mojility/coach-core'

const BrandingEditor = function ($scope, $element, initialDataInteractor, brandingInteractor, eventsService) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.feedbackManager = new FeedbackManager($element[ 0 ], {
      ready: 'Save Changes',
      busy: 'Saving...',
      fail: 'Failed'
    })
  };

  $ctrl.save = function () {
    $ctrl.feedbackManager.start();

    brandingInteractor.updateBranding($ctrl.branding)
      .then(() => {
        $ctrl.feedbackManager.finish();
        eventsService.publishSystemMessage('Style successfully saved.');
        $ctrl.branding = brandingInteractor.defaultBranding;
        $scope.$digest();
      }, () => {
        eventsService.publishSystemError('Failed to save style.');
        $ctrl.feedbackManager.fail();
      })
  };
};

export default {
  name: 'brandingEditor',
  obj: {
    controller: BrandingEditor,
    templateUrl: 'components/branding_editor.html',
    bindings: {
      branding: '<',
      availableFonts: '<'
    }
  },
  deps: []
}